import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
  signal,
} from '@angular/core';
import { take } from 'rxjs';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { Laboratory } from 'src/app/_models/laboratory';
import { TabOptions } from 'src/app/_models/tab-options';
import { ActivatedRoute } from '@angular/router';
import { FluorescenceChannel } from 'src/app/_models/fluorescence-channel';
import { ErrorObject } from 'src/app/_models/error';
import { DeviceService } from 'src/app/_services/device.service';
import { deviceNavOptions } from 'src/app/_helpers/device-nav-options';
import { MatIcon } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { UnderlinedOptionTabToggleComponent } from 'src/app/_components/selection-controls/underlined-option-tab-toggle/underlined-option-tab-toggle.component';
import { LoadingSpinnerComponent } from 'src/app/_components/loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-fluorescence-channels',
  imports: [
    UnderlinedOptionTabToggleComponent,
    LoadingSpinnerComponent,
    MatTableModule,
    MatIcon,
  ],
  templateUrl: './fluorescence-channels.component.html',
  styleUrl: './fluorescence-channels.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FluorescenceChannelsComponent implements OnInit {
  private readonly authenticationService = inject(AuthenticationService);
  private readonly deviceService = inject(DeviceService);
  private readonly route = inject(ActivatedRoute);

  error = signal<ErrorObject>(null);

  deviceId: string;
  laboratory = signal<Laboratory>(null);

  fluorescenceChannels = signal<FluorescenceChannel[]>([]);
  fluorescenceChannelsLoading = signal(true);

  readonly displayedColumns = ['name', 'lowerBand', 'upperBand', 'led'];

  // Navigation
  navOptions: TabOptions[];

  // Permissions
  currentUser = this.authenticationService.currentUserValue;

  ngOnInit(): void {
    this.laboratory.update(() => this.authenticationService.selectedLaboratory);
    this.route.paramMap.pipe(take(1)).subscribe((params) => {
      this.deviceId = params.get('id');
      this.navOptions = deviceNavOptions(this.deviceId, this.currentUser?.role);
    });

    this.getFluorescenceChannels();
  }

  // Fluoroescence Channels do not change according to device - they are currently hardcoded.
  // If custom channels are added to the device, a new endpoint will be needed to retrieve them and this function will need to be updated.
  getFluorescenceChannels(): void {
    this.fluorescenceChannelsLoading.set(true);
    this.error.set(null);
    this.fluorescenceChannels.set([]);

    this.deviceService.getFluorescenceChannels().subscribe({
      next: (response: FluorescenceChannel[]) => {
        this.fluorescenceChannels.set(response);
        this.fluorescenceChannelsLoading.set(false);
      },
      error: (error: ErrorObject) => {
        this.fluorescenceChannelsLoading.set(false);
        this.error.set(error);
      },
    });
  }
}
